import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import routes from "./routes";
import Header from "./pages/header";
import Footer from "./pages/footer";
import { ChainProvider } from "./provider/ChainProvider";
import { WrappedLayout } from "./components/WrappedLayout";
import { RecoilRoot } from "recoil";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DeveloperProvider } from "./provider/DeveloperProvider";
// import { createTheme } from "@mui/material";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// const theme = createTheme({
//   typography: {
//     fontSize: 12,
//   },
// });

root.render(
  <ChainProvider>
    <BrowserRouter>
      <DeveloperProvider>
        <RecoilRoot>
          <Header />
          <Routes>
            <Route
              element={
                <WrappedLayout>
                  <Outlet />
                </WrappedLayout>
              }
            >
              {routes.map((data, index) => (
                <Route path={data.path} element={data.component} key={index} />
              ))}
            </Route>
          </Routes>
          <Footer />
          <ToastContainer />
        </RecoilRoot>
      </DeveloperProvider>
    </BrowserRouter>
  </ChainProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
